import { Modal } from 'antd';
import Button from 'app/components/Button';
import { Paragraph } from 'app/components/Typography/Paragraph';
import { useRef, useState } from 'react';
import { Typography } from 'antd';
import Panel from 'app/components/Layout/Panel';
import { Upload } from 'app/components/Form/Controls';
import classes from './Style.module.scss';
import { Formik, useFormikContext } from 'formik';
import Edit from './Edit';

const SubFormAdditionalInformation = (props) => {
  const { value } = props;
  const { documentLists } = value;
  const formikRef = useRef(null);
  const { values, setValues } = useFormikContext();
  const [edit, setEdit] = useState(false);

  return (
    <Panel
      className={classes.additionalInformation}
      contentClassName={classes.block}
      title="D) Additional Information"
      extra={
        <Button
          type="link"
          onClick={() => {
            setEdit(true);
          }}
        >
          Edit
        </Button>
      }
    >
      <Upload
        disabled
        value={documentLists}
        uploadButtonProps={{ hidden: true }}
        shouldRemove={false}
      />

      <div className={classes.remark}>
        <Typography.Title className={classes.title} level={4}>
          Remark
        </Typography.Title>
        <Paragraph className={classes.paragraph}>
          {value.remark || 'N/A'}
        </Paragraph>
      </div>
      <Modal
        open={edit}
        title="Additional Information"
        width="80%"
        cancelButtonProps={{ hidden: true }}
        onOk={() => {
          formikRef.current.submitForm();
          setEdit(false);
        }}
        onCancel={() => {
          setEdit(false);
        }}
        okText="Confirm"
        bodyStyle={{
          maxHeight: 650,
          overflowY: 'auto'
        }}
      >
        <Formik
          initialValues={values}
          enableReinitialize
          onSubmit={(values) => {
            setValues(values);
          }}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            return <Edit />;
          }}
        </Formik>
      </Modal>
    </Panel>
  );
};

export default SubFormAdditionalInformation;
